// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    mat-list-item:hover {
      background-color: #f5f5f5;
    }
    code {
      font-family: monospace;
      font-size: 14px;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/ai-test-detail/create-assignment-dialog.component.ts"],"names":[],"mappings":";IACI;MACE,yBAAyB;IAC3B;IACA;MACE,sBAAsB;MACtB,eAAe;IACjB","sourcesContent":["\n    mat-list-item:hover {\n      background-color: #f5f5f5;\n    }\n    code {\n      font-family: monospace;\n      font-size: 14px;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
